 <mat-toolbar class="noPadding">
        <div *ngIf="!isSmallDevice" class="toTheRight">{{ 'pages.landingpage.title' | translate }}</div>
      <img class="favoritenLogo" *ngIf="isSmallDevice"  src="//local.curion.ch/myDay/assets/Icone_Favoriten48orange.ico">

      <div class="add-button-container">
        <button matTooltip="Favorit Hinzufügen" mat-mini-fab color="primary" aria-label="Add a Dashboard" class="pluscolor" (click)="addDashboard()">
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </mat-toolbar>
  <div class="fullWidth">
  <app-landing-card
    class="favorites"
    [dashboardItems]="$dashboard | async"
  >
  </app-landing-card>
    <div class="untererRand"></div>

</div>
